import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { ConfirmationAlert, getOnlyToken } from "../../utils/commonFunctions";
import Loader from "../../Components/Loader";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import "./PhoneNumbers.css";

export default function PhoneNumbers() {
  const [searchTerm, setSearchTerm] = useState("");
  const [loading,setLoading] = useState(false)
  const [data, setData] = useState([]);
  const [workData, setWorkdata] = useState([])
  const [agentData, setAgentData] = useState([]);
  const [callTypes, setCallTypes] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const token = getOnlyToken();

  useEffect(()=>{
    fetchNumbers()
      getWorkFlow()
      getAgents()
  },[])

  const fetchNumbers = async () => {
    try {
      setLoading(true)
      const config = { headers: { Authorization: `Bearer ${token}` } };

      const res = await axios.get('ivr/phone-numbers/', config)

      if (res.status === 200) {
        setData(res.data.data)
        const initialCallTypes = {};
        res.data.data.forEach(row => {
          if (row.flow_type) {
            initialCallTypes[row.line_id] = row.flow_type;
          }
        });
        setCallTypes(initialCallTypes);
        setLoading(false)
      }
    } catch (error) {

    }
  }


  const getWorkFlow = async () => {
    try {
      setLoading(true)
      
            const config = { headers: { Authorization: `Bearer ${token}` } };
      const res = await axios.get(`/ivr/workflow-config/`,config);

      if (res.status === 200) {
        setWorkdata(res.data)
      }

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false)

    }
  }


  const getAgents = async () => {
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const res = await axios.get('api/agents/agent-dropdown/?agent_type=out-bound', config);
      if (res.status === 200) {
        setAgentData(res.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCallTypeChange = (lineId, value) => {
    setCallTypes(prev => ({ ...prev, [lineId]: value }));
  };

  const handleAssignChange = (manageLineId, id, type) => {
    const isAgent = type === "agent";
    ConfirmationAlert(
      `Do you want to update the ${isAgent ? "agent" : "workflow"} assignment?`,
      "Update",
      async () => {
        try {
          setLoading(true);
          const config = { headers: { Authorization: `Bearer ${token}` } };
          const selectedCallType = callTypes[manageLineId];
          const payload = {
            manage_line_id: parseInt(manageLineId),
            ...(isAgent ? { agent_id: parseInt(id) } : { workflow_config_id: parseInt(id) }),
            ...(selectedCallType !== "inbound" && { call_type: selectedCallType || "both" })
          };
          const res = await axios.post('ivr/workflow-config/assign-manage-line/', payload, config);
          setSuccessMessage(res.data.message || `${isAgent ? "Agent" : "Workflow"} assigned successfully!`);
          setShowSuccessModal(true);
          fetchNumbers();
        } catch (error) {
          setErrorMessage(error.response?.data?.message || `Failed to assign ${isAgent ? "agent" : "workflow"}. Please try again.`);
          setShowErrorModal(true);
        } finally {
          setLoading(false);
        }
      }
    );
  };

  const columns = [
    {
      name: "S.No",
      width: "80px",
      center: true,
      cell: (row, index) => index + 1,
    },
    {
      name: "Phone Number",
      selector: (row) => row.line,
      sortable: true,
      center: true,
      grow: 2,
    },
    {
      name: 'Line type',
      selector: (row) => row.line_type,
      center: true,
      grow: 1,
    },
    {
      name: "Call Type",
      center: true,
      grow: 1,
      cell: (row) => {
        const selectedType = callTypes[row.line_id] || row.flow_type || '';
        return (
          <select
            className="form-select form-select-sm"
            value={selectedType}
            onChange={(e) => handleCallTypeChange(row.line_id, e.target.value)}
            style={{ backgroundColor: '#2A2D3F', color: '#ffffffff', border: '1px solid rgba(170, 175, 180, 1)' }}
          >
            <option value="">Select Call Type</option>
            <option value="inbound">Inbound</option>
            <option value="outbound">Outbound</option>
            <option value="both">Both</option>
          </select>
        );
      }
    },
    {
      name: "Agent",
      center: true,
      grow: 2,
      cell: (row) => {
        const selectedType = callTypes[row.line_id] || '';
        if (selectedType !== 'outbound' && selectedType !== 'both') {
          return <span className="text-secondary">—</span>;
        }
        return (
          <select
            className="form-select form-select-sm"
            value={row.agent || ''}
            onChange={(e) => handleAssignChange(row.line_id, e.target.value, "agent")}
            style={{ backgroundColor: '#2A2D3F', color: '#ffffffff', border: '1px solid rgb(133, 187, 241)' }}
          >
            <option value=""> -- Select Agent --</option>
            {agentData.map(a => (
              <option key={a.agent_id} value={a.agent_id}>{a.agent_name}</option>
            ))}
          </select>
        );
      }
    },
    {
      name: "Workflow",
      center: true,
      grow: 2,
      cell: (row) => {
        const selectedType = callTypes[row.line_id] || '';
        if (selectedType !== 'inbound' && selectedType !== 'both') {
          return <span className="text-secondary">—</span>;
        }
        return (
          <select
            className="form-select form-select-sm"
            value={row.workflow || ''}
            onChange={(e) => handleAssignChange(row.line_id, e.target.value, "workflow")}
            style={{ backgroundColor: '#2A2D3F', color: '#ffffffff', border: '1px solid rgb(98, 122, 32)' }}
          >
            <option value=""> -- Select Workflow --</option>
            {workData.map(w => (
              <option key={w.id} value={w.id}>{w.name}</option>
            ))}
          </select>
        );
      }
    },
  ];

  const handleSearch = () => {
    console.log("Searching for:", searchTerm);
  }

  // DARK MODE TABLE STYLE
const customStyles = {
  table: {
    style: {
      backgroundColor: "#1A1C2B",
      color: "#FFFFFF",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#1F2233",
      borderBottom: "1px solid rgb(70,79,91)",
      minHeight: "45px",
    },
  },
  headCells: {
    style: {
      color: "#fff",
      fontSize: "14px",
      fontWeight: 600,
      borderRight: "1px solid rgb(70,79,91)",
    },
  },
  rows: {
    style: {
      backgroundColor: "#1A1C2B",
      color: "#fff",
      minHeight: "48px",
      "&:hover": {
        backgroundColor: "#23263A",
      },
    },
  },
  cells: {
    style: {
      borderBottom: "1px solid rgb(70,79,91)",
      fontSize: "14px",
      color: "#E1E1E1",
    },
  },
  pagination: {
    style: {
      backgroundColor: "#1A1C2B",
      color: "#FFFFFF",
      borderTop: "1px solid rgb(70,79,91)",
    },
    pageButtonsStyle: {
      color: "#FFFFFF !important",
      fill: "#FFFFFF !important",
      "&:hover": {
        backgroundColor: "#2A2D3F",
      },
      "&:disabled": {
        color: "#777 !important",
        fill: "#777 !important",
      },
    },
  },

  noData: {
    style: {
      backgroundColor: "transparent",
      color: "#fff",
      padding: "20px",
    },
  },
};

  return (
    <div className="phone-wrapper">

      {/* PAGE HEADER */}
      <div className=" mb-2">
          <h3 className=" mb-2 fs-2 fw-bold text-success">
        {/* <i className="bi bi-telephone text-white me-1"></i> */}
        Purchased Phone Numbers
      </h3>
      <p className="text-secondary ">Search and manage assigned phone numbers</p>
       
        </div>

      

      {/* SEARCH BAR */}
      <div className="d-flex gap-3  mb-3 justify-content-end">
      <div>
          <div className="col-md-12 d-flex justify-content-end">
          <div
            style={{ position: "relative", maxWidth: "250px", width: "100%" }}
          >
            <i
              className="bi bi-search"
              style={{
                position: "absolute",
                left: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#6c757d",
                fontSize: "14px",
              }}
            ></i>

            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search numbers..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ paddingLeft: "32px" }}
            />
          </div>

          <Button
            onClick={handleSearch} className="btn-sm mx-2">Search</Button>
        </div>
      </div>
         <Button
          onClick={() => navigate('/numberbuying')}
          className="btn-sm px-2 btn-success d-flex align-items-center gap-2  fw-semibold"
        >
          <i className="bi bi-telephone-plus "></i>
          Buy New Number
        </Button>
      </div>
      {/* DATA TABLE */}
      <div className="dark-table-container">

        {loading ? <div className="col-12 bg-black d-flex justify-content-center align-items-center pt-5 mt-5">
              <Loader />
            </div> :
             <DataTable
          columns={columns}
          data={data}
          pagination
          customStyles={customStyles}
        />
             }
       
      </div>

      {/* SUCCESS MODAL */}
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
        backdrop="static"
        contentClassName="border-0 shadow-lg rounded-4"
      >
        <Modal.Body className="p-4 text-center">
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
            style={{
              width: 80,
              height: 80,
              background: "linear-gradient(135deg, #28a745, #20c997)",
            }}
          >
            <i className="bi bi-check-lg text-white" style={{ fontSize: "2.5rem" }} />
          </div>
          <h5 className="fw-bold mb-2">Success</h5>
          <p className="text-muted mb-4">{successMessage}</p>
          <Button
            variant="success"
            className="px-4 fw-semibold rounded-pill"
            onClick={() => setShowSuccessModal(false)}
          >
            Done
          </Button>
        </Modal.Body>
      </Modal>

      {/* ERROR MODAL */}
      <Modal
        show={showErrorModal}
        onHide={() => setShowErrorModal(false)}
        centered
        backdrop="static"
        contentClassName="border-0 shadow-lg rounded-4"
      >
        <Modal.Body className="p-4 text-center">
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
            style={{
              width: 80,
              height: 80,
              background: "linear-gradient(135deg, #dc3545, #ff6b6b)",
            }}
          >
            <i className="bi bi-x-lg text-white" style={{ fontSize: "2.2rem" }} />
          </div>
          <h5 className="fw-bold mb-2">Something went wrong</h5>
          <p className="text-muted mb-4">{errorMessage}</p>
          <Button
            variant="outline-danger"
            className="px-4 fw-semibold rounded-pill"
            onClick={() => setShowErrorModal(false)}
          >
            Close
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
}


